// VITE_API_BASE_URL takes priority; fallback to VITE_API_URL + /api/v1
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api/v1` : 'http://localhost:3000/api/v1')

export function getWsBaseUrl(): string {
  return API_BASE_URL.replace(/^http/, 'ws').replace(/\/api\/v1$/, '')
}
